import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import { Localized } from "@fluent/react";
import { SyntheticEvent, useState } from "react";
import { BugsList } from "../../support/components/BugsList";

type CompanySystemInformationTab = "reportedBugs";

export const CompanySystemInformation = () => {
    const [tab, setTab] = useState<CompanySystemInformationTab>("reportedBugs");

    const handleTabChange = (_: SyntheticEvent, value: CompanySystemInformationTab) => {
        setTab(value);
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "calc(100vh - 112px)", minHeight: 400 }}>
            <TabContext value={tab}>
                <TabList onChange={handleTabChange}>
                    <Tab
                        value="reportedBugs"
                        label={<Localized id="company-system-information-tab-reported-bugs">Reported bugs</Localized>}
                    />
                </TabList>
                <TabPanel value="reportedBugs" sx={{ px: 0, pb: 0, flex: 1, minHeight: 0 }}>
                    <BugsList mode="company" />
                </TabPanel>
            </TabContext>
        </Box>
    );
};